
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire887a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire887a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $383a684ecdaf70e9$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["kzo7M","index.5940ceb4.js","5nATQ","build.a46194ab.js","hhrqX","signer-evm.f0c51ffc.js","2tWCa","signer-evm.b55105c8.js","5jfCG","signer-cosmos.9b2b3554.js","dMJKs","signer-cosmos.9b825b0f.js","CY3OB","signer-cosmos.cb24dca5.js","aFk6M","signer-cosmos.563b256e.js","82l5f","signer-cosmos.bb463e0f.js","aQeRx","signer-cosmos.ad9ece40.js","iL435","Eth.9e2b9ed2.js","7z23r","Solana.43f986e5.js","9AjK2","TransportWebHID.2c73e485.js","h79Ld","ethereum.1f7a76fa.js","lXHHP","solana.3568487e.js","lVW52","cosmosSigner.a313aa48.js","gVT3l","utxoSigner.e679732d.js","eX791","signer-sui.37a39990.js","ay42H","evm.2b6d37af.js","3FLfZ","ui.3b6064a3.js","6Vvpy","ton-signer.06791525.js","du9S3","connect-web.70a522e0.js","3KYkf","ethereum.5da5f979.js","a1DH5","dist.9df86123.js","c918N","evm.392cffa9.js","3a28m","cosmos.2d68ce38.js","hPtqB","solana.835b18dc.js"]'));


//# sourceMappingURL=index.runtime.670507e6.js.map
